export const vatNumberRegex = {
  Nederland: /^NL\d{9}B\d{2}$/,
  Andorra: null,
  Aruba: null,
  België: /^BE0?\d{9}$/,
  Bulgarije: /^BG\d{9,10}$/,
  'Caribisch Nederland': null,
  Cyprus: /^CY\d{8}[A-Z]$/,
  Curaçao: null,
  Denemarken: /^DK\d{8}$/,
  Duitsland: /^DE\d{9}$/,
  Estland: /^EE\d{9}$/,
  Finland: /^FI\d{8}$/,
  Frankrijk: /^FR[A-HJ-NP-Z0-9]{2}\d{9}$/,
  Griekenland: /^EL\d{9}$/,
  Hongarije: /^HU\d{8}$/,
  Ierland: /^IE\d{7}[A-W][A-IW]?$/,
  Italië: /^IT\d{11}$/,
  Kroatië: /^HR\d{11}$/,
  Letland: /^LV\d{11}$/,
  Litouwen: /^LT\d{9,12}$/,
  Luxemburg: /^LU\d{8}$/,
  Malta: /^MT\d{8}$/,
  Monaco: /^FR[A-HJ-NP-Z0-9]{2}\d{9}$/,
  Noorwegen: /^NO\d{9}MVA$/,
  Oostenrijk: /^ATU\d{8}$/,
  Polen: /^PL\d{10}$/,
  Portugal: /^PT\d{9}$/,
  Roemenië: /^RO\d{2,10}$/,
  'San Marino': null,
  Slovenië: /^SI\d{8}$/,
  Slowakije: /^SK\d{10}$/,
  Spanje: /^ES[A-Z0-9]{1}\d{7}[A-Z0-9]{1}$/,
  'Sint Maarten': null,
  Tsjechië: /^CZ\d{8,10}$/,
  'Verenigd Koninkrijk': /^GB\d{9}$/,
  Zweden: /^SE\d{12}$/,
  Zwitserland: /^CHE\d{9}(MWST|TVA|IVA)$/,
  Vaticaanstad: null,
  'Verenigde Staten': /^\d{2}-\d{7}$/,
};
